import React, { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Chip,
    Grid,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Pagination,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
} from "@mui/material";
import { EditOutlined, DeleteOutline, Add } from "@mui/icons-material";
import { db, auth } from "../../firebase";
import { collection, getDocs, setDoc, doc, deleteDoc, Timestamp, query, where, getDoc, addDoc, getCountFromServer } from "firebase/firestore";
import Swal from "sweetalert2";
import { Autocomplete } from "@mui/material";

const PAGE_SIZE = 5;
const STATUS_OPTIONS = ["Active", "Inactive"];
const CLASS_OPTIONS = [
    "Nursery", "LKG", "UKG",
    "1st", "2nd", "3rd", "4th", "5th",
    "6th", "7th", "8th", "9th", "10th",
    "11th", "12th"
];

const SCHOOL_TYPE = ["Day School", "Residential"];

const BOARD_OPTIONS = ["State", "CBSE", "ICSE", "IB"];



function Admissionenquiry() {
    const [enquiries, setEnquiries] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [schoolId, setSchoolId] = useState(null);
    // Function to get current date, day, and time
    const getCurrentDateTime = () => {
        const now = new Date();
        const dateOfVisit = now.toISOString().split("T")[0]; // YYYY-MM-DD
        const timeOfVisit = now.toTimeString().split(" ")[0].slice(0, 5); // HH:MM
        const dayOfVisit = now.toLocaleDateString("en-US", { weekday: "long" }); // e.g., Monday
        return { dateOfVisit, timeOfVisit, dayOfVisit };
    };

    // When opening Add Enquiry
    const openAddForm = () => {
        const { dateOfVisit, timeOfVisit, dayOfVisit } = getCurrentDateTime();
        setForm({
            dateOfVisit,
            dayOfVisit,
            timeOfVisit,
            admissionGrade: "",
            daySchoolOrResidential: "",
            visitorsName: "",
            relationWithStudent: "",
            studentName: "",
            birthPlace: "",
            dob: "",
            presentGrade: "",
            standard: "",
            division: "",
            schoolName: "",
            board: "",
            addressHouseNo: "",
            addressHouseName: "",
            street: "",
            cityVillage: "",
            taluka: "",
            district: "",
            state: "",
            pin: "",
            email: "",
            fatherPhone: "",
            motherPhone: "",
            fatherProfession: "",
            motherProfession: "",
            sourceInfo: "",
            websiteVisited: "No",
            additionalInfo: "",
            staff: "",
            status: "Active",
        });
        setEditingId(null);
        setOpenDialog(true);
    };
    const [form, setForm] = useState({

        dateOfVisit: "",
        dayOfVisit: "",
        timeOfVisit: "",
        admissionGrade: "",
        daySchoolOrResidential: "",
        visitorsName: "",
        relationWithStudent: "",
        studentName: "",
        birthPlace: "",
        dob: "",
        presentGrade: "",
        standard: "",
        division: "",
        schoolName: "",
        board: "",
        addressHouseNo: "",
        addressHouseName: "",
        street: "",
        cityVillage: "",
        taluka: "",
        district: "",
        state: "",
        pin: "",
        email: "",
        fatherPhone: "",
        motherPhone: "",
        fatherProfession: "",
        motherProfession: "",
        sourceInfo: "",
        websiteVisited: "No",
        additionalInfo: "",
        staff: "",
        status: "Active",
    });

    useEffect(() => {
        const fetchSchoolId = async () => {
            try {
                const user = auth.currentUser;
                if (!user) return;

                // ⚡ Direct document fetch (FAST)
                const userDoc = await getDoc(doc(db, "users", user.uid));

                if (userDoc.exists()) {
                    setSchoolId(userDoc.data().schoolId);
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchSchoolId();
    }, []);

    /* ================= LOAD ENQUIRIES ================= */
    useEffect(() => {
        if (!schoolId) return;
        loadEnquiries();
    }, [schoolId]);

    const loadEnquiries = async () => {
        const q = query(collection(db, "admissionEnquiries"), where("schoolId", "==", schoolId));
        const snap = await getDocs(q);
        setEnquiries(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    };

    /* ================= FORM HANDLER ================= */
    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    /* ================= VALIDATION ================= */
    const validateForm = () => {
        const requiredFields = [
            "visitorsName",
            "studentName",
            "fatherPhone",
        ];
        for (let field of requiredFields) {
            if (!form[field] || !form[field].toString().trim()) {
                Swal.fire("Error", `Please fill the ${field}`, "error");
                return false;
            }
        }
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(form.fatherPhone)) {
            Swal.fire("Error", "Father's phone number is invalid", "error");
            return false;
        }

        return true;
    };

    /* ================= SAVE / UPDATE ================= */
    const saveEnquiry = async () => {
        if (!validateForm()) return;
        if (!schoolId) {
            Swal.fire("Error", "School ID not found", "error");
            return;
        }

        try {
            const id = editingId || doc(collection(db, "admissionEnquiries")).id;
            await setDoc(doc(db, "admissionEnquiries", id), {
                ...form,
                schoolId,
                createdTime: editingId ? form.createdTime : Timestamp.now(),
            });
            Swal.fire("Success", editingId ? "Enquiry updated" : "Enquiry added", "success");
            setForm({
                dateOfVisit: "",
                dayOfVisit: "",
                timeOfVisit: "",
                admissionGrade: "",
                daySchoolOrResidential: "",
                visitorsName: "",
                relationWithStudent: "",
                studentName: "",
                birthPlace: "",
                dob: "",
                presentGrade: "",
                standard: "",
                division: "",
                schoolName: "",
                board: "",
                addressHouseNo: "",
                addressHouseName: "",
                street: "",
                cityVillage: "",
                taluka: "",
                district: "",
                state: "",
                pin: "",
                email: "",
                fatherPhone: "",
                motherPhone: "",
                fatherProfession: "",
                motherProfession: "",
                sourceInfo: "",
                websiteVisited: "No",
                additionalInfo: "",
                staff: "",
                status: "Active",
            });

            // 🔥 AUTO SEND WHATSAPP TO SINGLE USER
            if (form.fatherPhone) {
                await sendSingleWhatsApp(form.fatherPhone);
            }

            setEditingId(null);
            setOpenDialog(false);
            loadEnquiries();
        } catch (error) {
            Swal.fire("Error", error.message, "error");
            console.log(error.message);

        }
    };

    /* ================= EDIT ================= */
    const editEnquiry = (e) => {
        setForm(e);
        setEditingId(e.id);
        setOpenDialog(true);
    };

    /* ================= DELETE ================= */
    const deleteEnquiry = async (id) => {
        const res = await Swal.fire({
            title: "Delete enquiry?",
            icon: "warning",
            showCancelButton: true,
        });
        if (!res.isConfirmed) return;

        await deleteDoc(doc(db, "admissionEnquiries", id));
        Swal.fire("Deleted", "Enquiry removed", "success");
        loadEnquiries();
    };

    /* ================= FILTER & PAGINATION ================= */
    const filtered = enquiries.filter(
        (e) =>
            e.visitorsName?.toLowerCase().includes(search.toLowerCase()) ||
            e.studentName?.toLowerCase().includes(search.toLowerCase())
    );
    const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);


    const sendSingleWhatsApp = async (mobile) => {

        try {

            const walletDoc = await getDoc(doc(db, "wallets", "0YVnAJmiq8cajkf4ufE5a8xYoFQ2")); // Adjust ID as per your DB
            const totalMessages = walletDoc.exists() ? walletDoc.data().totalMessages : 0;

            // Fetch the count of sent messages (more efficient than getDocs)
            const historyRef = collection(db, "whatsapphistory");
            const historyQuery = query(historyRef);
            const historySnapshot = await getCountFromServer(historyQuery);
            const sentCount = historySnapshot.data().count;
            const remaining = totalMessages - sentCount;
            if (remaining < 0) {
                Swal.fire("Error", "Whatsapp Wallet Balance is Low", "error");

                return
            }

            // 🔥 FETCH WHATSAPP CONFIG FROM FIRESTORE
            const whatsappSnap = await getDocs(collection(db, "whatsapp"));

            if (whatsappSnap.empty) {
                return;
            }

            const whatsappData = whatsappSnap.docs[0].data();
            const wabaid = whatsappData.phoneid;       // ✅ dynamic
            const accesstoken = whatsappData.accesstoken; // ✅ dynamic
            let success = 0;

            let status = "failed";

            const payload = {
                messaging_product: "whatsapp",
                to: `91${mobile}`,
                type: "template",
                template: {
                    name: "admission_enquiry",
                    language: { code: "en" },
                    components: [
                        {
                            type: "body",
                            parameters: [],
                        }
                    ],
                },
            };

            try {
                const r = await fetch(
                    `https://graph.facebook.com/v22.0/${wabaid}/messages`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${accesstoken}`,
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const res = await r.json();

                if (res.messages?.[0]?.id) {
                    status = "sent";
                    success++;
                } else {
                    console.log("WhatsApp Error:", res);
                }
            } catch (err) {
                console.log("Fetch Error:", err);
                status = "failed";
            }

            // 🔥 SAVE HISTORY
            await addDoc(collection(db, "whatsapphistory"), {
                mobile: mobile,
                postTitle: "Admission Enquiry",
                type: "template",
                status,
                timestamp: new Date().toISOString(),
            });

            await new Promise((res) => setTimeout(res, 300));

        } catch (err) {
            console.log(err);
        }

    };

    return (
        <Box p={1}>
            <Typography variant="h5" fontWeight={800} mb={2}>
                Admission Enquiries
            </Typography>

            <Button
                variant="contained"
                startIcon={<Add />}
                sx={{ mb: 2 }}
                onClick={() => {
                    openAddForm()
                }}
            >
                Add Enquiry
            </Button>

            <TextField
                fullWidth size="small"
                label="Search by Visitor or Student Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2 }}
            />

            <Card>
                <CardContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr No</TableCell>
                                <TableCell>Visitor</TableCell>
                                <TableCell>Student</TableCell>
                                <TableCell>Father Phone</TableCell>
                                <TableCell>Mother Phone</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginated.map((e, index) => (
                                <TableRow key={e.id}>
                                    <TableCell>{(page - 1) * PAGE_SIZE + index + 1}</TableCell>
                                    <TableCell>{e.visitorsName}</TableCell>
                                    <TableCell>{e.studentName}</TableCell>
                                    <TableCell>{e.fatherPhone}</TableCell>
                                    <TableCell>{e.motherPhone}</TableCell>
                                    <TableCell>
                                        <Chip label={e.status} color={e.status === "Active" ? "success" : "default"} size="small" />
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton color="primary" onClick={() => editEnquiry(e)}>
                                            <EditOutlined />
                                        </IconButton>
                                        <IconButton color="error" onClick={() => deleteEnquiry(e.id)}>
                                            <DeleteOutline />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Box display="flex" justifyContent="center" mt={2}>
                        <Pagination
                            count={Math.ceil(filtered.length / PAGE_SIZE)}
                            page={page}
                            onChange={(e, v) => setPage(v)}
                        />
                    </Box>
                </CardContent>
            </Card>

            {/* ================= DIALOG ================= */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth >
                <DialogTitle>{editingId ? "Edit Enquiry" : "Add Enquiry"}</DialogTitle>
                <DialogContent>
                    <Grid className="row" spacing={2} mt={1}>
                        {/* Row 1 */}
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Date of Visit" name="dateOfVisit" type="date" value={form.dateOfVisit} onChange={handleChange} InputLabelProps={{ shrink: true }} />
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Day" name="dayOfVisit" value={form.dayOfVisit} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Time" name="timeOfVisit" type="time" value={form.timeOfVisit} onChange={handleChange} InputLabelProps={{ shrink: true }} />
                        </Grid>

                        {/* Row 2 */}
                        <Grid className="col-sm-4 mb-3">
                            <FormControl fullWidth size="small">
                                <InputLabel>Admission Grade</InputLabel>
                                <Select
                                    name="admissionGrade"
                                    value={form.admissionGrade}
                                    onChange={handleChange}
                                >
                                    {CLASS_OPTIONS.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <FormControl fullWidth size="small">
                                <InputLabel>School Type</InputLabel>
                                <Select
                                    name="daySchoolOrResidential"
                                    value={form.daySchoolOrResidential}
                                    onChange={handleChange}
                                >
                                    {SCHOOL_TYPE.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Row 3 */}
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Visitor's Name*" name="visitorsName" value={form.visitorsName} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Relation with Student" name="relationWithStudent" value={form.relationWithStudent} onChange={handleChange} />
                        </Grid>

                        {/* Row 4 */}
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Student Name*" name="studentName" value={form.studentName} onChange={handleChange} />
                        </Grid>
                         <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Father Phone*" name="fatherPhone" value={form.fatherPhone} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Birth Place" name="birthPlace" value={form.birthPlace} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Date of Birth" name="dob" type="date" value={form.dob} onChange={handleChange} InputLabelProps={{ shrink: true }} />
                        </Grid>

                        {/* Row 5 */}
                        <Grid className="col-sm-4 mb-3">
                            <FormControl fullWidth size="small">
                                <InputLabel>Standard</InputLabel>
                                <Select
                                    name="standard"
                                    value={form.standard}
                                    onChange={handleChange}
                                >
                                    {CLASS_OPTIONS.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="Division" name="division" value={form.division} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-4 mb-3">
                            <TextField fullWidth size="small" label="School Name" name="schoolName" value={form.schoolName} onChange={handleChange} />
                        </Grid>

                    </Grid>

                    <Divider />
                    <Grid className="row">
                        <Grid className="col-sm-3 mb-3">
                            <FormControl fullWidth size="small">
                                <InputLabel>Board</InputLabel>
                                <Select
                                    name="board"
                                    value={form.board}
                                    onChange={handleChange}
                                >
                                    {BOARD_OPTIONS.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="House No" name="addressHouseNo" value={form.addressHouseNo} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="House Name" name="addressHouseName" value={form.addressHouseName} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Street" name="street" value={form.street} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="City/Village" name="cityVillage" value={form.cityVillage} onChange={handleChange} />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Taluka" name="taluka" value={form.taluka} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="District" name="district" value={form.district} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="State" name="state" value={form.state} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Pin" name="pin" value={form.pin} onChange={handleChange} />
                        </Grid>

                        {/* Row 7 - Contacts */}
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Email" name="email" value={form.email} onChange={handleChange} />
                        </Grid>
                       
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Mother Phone" name="motherPhone" value={form.motherPhone} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Father Profession" name="fatherProfession" value={form.fatherProfession} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Mother Profession" name="motherProfession" value={form.motherProfession} onChange={handleChange} />
                        </Grid>

                        {/* Row 8 */}
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="How did you know about the School" name="sourceInfo" value={form.sourceInfo} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <FormControl fullWidth size="small">
                                <InputLabel>Website Visited</InputLabel>
                                <Select name="websiteVisited" value={form.websiteVisited} onChange={handleChange}>
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Additional Info" name="additionalInfo" value={form.additionalInfo} onChange={handleChange} />
                        </Grid>
                        <Grid className="col-sm-3 mb-3">
                            <TextField fullWidth size="small" label="Staff particulars Ms / Mr" name="staff" value={form.staff} onChange={handleChange} />
                        </Grid>

                        {/* Row 9 - Status */}
                        <Grid className="col-sm-3 mb-3">
                            <FormControl fullWidth size="small">
                                <InputLabel>Status</InputLabel>
                                <Select name="status" value={form.status} onChange={handleChange}>
                                    {STATUS_OPTIONS.map((s) => (
                                        <MenuItem key={s} value={s}>
                                            {s}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button variant="contained" onClick={saveEnquiry}>
                        {editingId ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default Admissionenquiry;